module.exports = __webpack_public_path__ + "img/1588.7103b5e8.gif";